// src/app/features/warehouse/store/warehouse.actions.ts

import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  PaginatedResponse,
  InvoiceListItem,
  InvoiceDetail,
  InvoiceSearchParams,
  Article,
  ArticleSearchParams,
  ArticleType,
  ArticleTypeSearchParams,
  StockItem,
  StockSearchParams,
  StockMovementResponse,
  StockMovementParams,
  LowStockParams,
  KomitentListItem,
  KomitentDetail,
  KomitentSearchParams,
  WarehouseSummary,
} from '../models/warehouse.model';

// ── INVOICES (paginated search) ─────────────────────────────────────────────

export const InvoicesActions = createActionGroup({
  source: 'Warehouse/Invoices',
  events: {
    'Search':  props<{ params: InvoiceSearchParams }>(),
    'Success': props<{ data: PaginatedResponse<InvoiceListItem> }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});

// ── INVOICE DETAIL (keyed by id) ────────────────────────────────────────────

export const InvoiceDetailActions = createActionGroup({
  source: 'Warehouse/InvoiceDetail',
  events: {
    'Load':    props<{ id: number; forceReload?: boolean }>(),
    'Success': props<{ id: number; data: InvoiceDetail }>(),
    'Failure': props<{ id: number; error: string }>(),
    'Clear':   props<{ id: number }>(),
  },
});

// ── ARTICLES (paginated search) ─────────────────────────────────────────────

export const ArticlesActions = createActionGroup({
  source: 'Warehouse/Articles',
  events: {
    'Search':  props<{ params: ArticleSearchParams }>(),
    'Success': props<{ data: PaginatedResponse<Article> }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});

// ── ARTICLE TYPES (paginated search) ────────────────────────────────────────

export const ArticleTypesActions = createActionGroup({
  source: 'Warehouse/ArticleTypes',
  events: {
    'Search':  props<{ params: ArticleTypeSearchParams }>(),
    'Success': props<{ data: PaginatedResponse<ArticleType> }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});

// ── STOCK (paginated search) ────────────────────────────────────────────────

export const StockActions = createActionGroup({
  source: 'Warehouse/Stock',
  events: {
    'Search':  props<{ params: StockSearchParams }>(),
    'Success': props<{ data: PaginatedResponse<StockItem> }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});

// ── STOCK MOVEMENTS (keyed by artId) ────────────────────────────────────────

export const StockMovementsActions = createActionGroup({
  source: 'Warehouse/StockMovements',
  events: {
    'Load':    props<{ artId: number; params: StockMovementParams; forceReload?: boolean }>(),
    'Success': props<{ artId: number; data: StockMovementResponse }>(),
    'Failure': props<{ artId: number; error: string }>(),
    'Clear':   props<{ artId: number }>(),
  },
});

// ── LOW STOCK (paginated search) ────────────────────────────────────────────

export const LowStockActions = createActionGroup({
  source: 'Warehouse/LowStock',
  events: {
    'Search':  props<{ params: LowStockParams }>(),
    'Success': props<{ data: PaginatedResponse<StockItem> }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});

// ── KOMITENTS (paginated search) ────────────────────────────────────────────

export const KomitentsActions = createActionGroup({
  source: 'Warehouse/Komitents',
  events: {
    'Search':  props<{ params: KomitentSearchParams }>(),
    'Success': props<{ data: PaginatedResponse<KomitentListItem> }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});

// ── KOMITENT DETAIL (keyed by id) ───────────────────────────────────────────

export const KomitentDetailActions = createActionGroup({
  source: 'Warehouse/KomitentDetail',
  events: {
    'Load':    props<{ id: number; forceReload?: boolean }>(),
    'Success': props<{ id: number; data: KomitentDetail }>(),
    'Failure': props<{ id: number; error: string }>(),
    'Clear':   props<{ id: number }>(),
  },
});

// ── SUMMARY (dashboard) ────────────────────────────────────────────────────

export const SummaryActions = createActionGroup({
  source: 'Warehouse/Summary',
  events: {
    'Load':    props<{ forceReload?: boolean }>(),
    'Success': props<{ data: WarehouseSummary }>(),
    'Failure': props<{ error: string }>(),
  },
});
